(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {

    /* =====================================================
       COLLECTION STORY — SCROLL REVEAL
       ===================================================== */

    const revealItems = document.querySelectorAll(
      ".sb-collection-story-reveal, .sb-collection-logo-reveal, .sb-collection-lineup-card-reveal, .sb-collection-card-reveal, .sb-collection-title-reveal"
    );

    if (revealItems.length) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.16,
        rootMargin: "0px 0px -8% 0px"
      });

      revealItems.forEach(function (el) {
        observer.observe(el);
      });
    }

    /* =====================================================
       COLLECTION GALLERIES — STAGGERED IMAGE REVEAL
       Apparition depuis le bas, décalée de gauche à droite,
       pour toutes les images (statique <= 3 ou carrousel > 3),
       clones de boucle inclus.
       ===================================================== */

    const reducedMotion = window.matchMedia
      ? window.matchMedia("(prefers-reduced-motion: reduce)")
      : null;

    const GALLERY_REVEAL_STEP = 110;
    const GALLERY_REVEAL_BASE = 160;

    function revealGallery(gallery) {
      if (gallery.dataset.sbGalleryRevealed === "1") return;
      gallery.dataset.sbGalleryRevealed = "1";
      gallery.classList.add("is-gallery-reveal-visible");

      const track =
        gallery.querySelector("[data-sb-collection-gallery-track]") || gallery;
      const items = Array.from(
        track.querySelectorAll("[data-sb-collection-gallery-item]")
      );

      /* Décalage recalculé selon l'ordre visuel gauche -> droite
         (clones de bord compris), pour une cascade cohérente. */
      items.forEach(function (item, index) {
        item.classList.add("sb-collection-gallery-image-reveal");
        item.style.setProperty(
          "--sb-collection-gallery-image-reveal-delay",
          (index * GALLERY_REVEAL_STEP + GALLERY_REVEAL_BASE) + "ms"
        );
      });

      /* Reflow : applique le décalage avant de lancer la transition. */
      void track.offsetWidth;

      items.forEach(function (item) {
        item.classList.add("is-visible");
      });
    }

    document.querySelectorAll("[data-sb-collection-gallery]").forEach(function (gallery) {
      if (
        (reducedMotion && reducedMotion.matches) ||
        !("IntersectionObserver" in window)
      ) {
        revealGallery(gallery);
        return;
      }

      const galleryRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealGallery(entry.target);
          galleryRevealObserver.unobserve(entry.target);
        });
      }, {
        threshold: 0.12,
        rootMargin: "0px 0px -8% 0px"
      });

      galleryRevealObserver.observe(gallery);
    });

    /* =====================================================
       COLLECTION STORY — ADAPTIVE GALLERIES
       ===================================================== */

    function initCollectionStoryGalleries() {
      const galleries = document.querySelectorAll("[data-sb-collection-gallery]");

      galleries.forEach(function (gallery) {
        const track = gallery.querySelector("[data-sb-collection-gallery-track]");
        const segments = Array.from(gallery.querySelectorAll("[data-sb-collection-gallery-progress]"));
        const previousButton = gallery.querySelector("[data-sb-collection-gallery-previous]");
        const nextButton = gallery.querySelector("[data-sb-collection-gallery-next]");

        if (!track) return;

        let activeIndex = 0;
        let scrollFrame = null;
        let loopTimer = null;
        let resizeFrame = null;
        let desktopLoopReady = false;

        function getRealItems() {
          return Array.from(track.querySelectorAll("[data-sb-collection-gallery-item]:not([data-sb-collection-gallery-clone])"));
        }

        function getAllItems() {
          return Array.from(track.querySelectorAll("[data-sb-collection-gallery-item]"));
        }

        function isDesktopLoop() {
          return gallery.classList.contains("sb-collection-story-overview-gallery--carousel") &&
            window.matchMedia("(min-width: 641px)").matches;
        }

        function getTrackInset() {
          const styles = window.getComputedStyle(track);
          const paddingLeft = parseFloat(styles.paddingLeft);
          return Number.isFinite(paddingLeft) ? paddingLeft : 0;
        }

        function getTrackGap() {
          const styles = window.getComputedStyle(track);
          const gap = parseFloat(styles.columnGap || styles.gap);
          return Number.isFinite(gap) ? gap : 0;
        }

        function getMaximumScroll() {
          return Math.max(0, track.scrollWidth - track.clientWidth);
        }

        function setTrackScrollInstant(left) {
          const previousBehavior = track.style.getPropertyValue("scroll-behavior");
          const previousPriority = track.style.getPropertyPriority("scroll-behavior");

          track.style.setProperty("scroll-behavior", "auto", "important");
          track.scrollLeft = left;

          /* Force le navigateur à appliquer la position avant
             de rétablir le comportement fluide pour les clics utilisateur. */
          track.getBoundingClientRect();

          if (previousBehavior) {
            track.style.setProperty(
              "scroll-behavior",
              previousBehavior,
              previousPriority
            );
          } else {
            track.style.removeProperty("scroll-behavior");
          }
        }

        function getPairScroll(leftItem) {
          const pairWidth = (leftItem.offsetWidth * 2) + getTrackGap();
          const sideSpace = (track.clientWidth - pairWidth) / 2;
          const requested = leftItem.offsetLeft - sideSpace;
          return Math.min(getMaximumScroll(), Math.max(0, requested));
        }

        function getMobileScroll(item) {
          const requested = item.offsetLeft - getTrackInset();
          return Math.min(getMaximumScroll(), Math.max(0, requested));
        }

        function updateSegments(index) {
          const realCount = getRealItems().length;
          if (realCount === 0) return;

          activeIndex = ((index % realCount) + realCount) % realCount;

          segments.forEach(function (segment, segmentIndex) {
            const active = segmentIndex === activeIndex;
            segment.classList.toggle("is-active", active);
            if (active) segment.setAttribute("aria-current", "true");
            else segment.removeAttribute("aria-current");
          });
        }

        function removeClones() {
          track.querySelectorAll("[data-sb-collection-gallery-clone]").forEach(function (clone) {
            clone.remove();
          });

          desktopLoopReady = false;
        }

        function prepareClone(item, position) {
          const clone = item.cloneNode(true);

          clone.setAttribute("data-sb-collection-gallery-clone", position);

          clone.classList.remove(
            "sb-collection-story-reveal",
            "sb-collection-story-reveal--media",
            "sb-collection-story-reveal--soft",
            "sb-collection-story-delay-1",
            "sb-collection-story-delay-2",
            "sb-collection-story-delay-3",
            "sb-collection-gallery-image-reveal--mobile-static",
            "is-visible"
          );

          clone.removeAttribute("data-sb-collection-gallery-image-reveal");
          clone.removeAttribute("data-sb-collection-gallery-reveal-index");
          clone.style.removeProperty("--sb-collection-gallery-image-reveal-delay");

          /* Le clone apparaît avec les autres images : masqué tant que la
             galerie n'est pas révélée, visible une fois la galerie révélée
             (ou tout de suite si elle l'a déjà été, ex. redimensionnement). */
          if (
            gallery.dataset.sbGalleryRevealed === "1" ||
            (reducedMotion && reducedMotion.matches)
          ) {
            clone.classList.add("is-visible");
          }

          return clone;
        }

        function createClones() {
          removeClones();
          const realItems = getRealItems();
          if (!isDesktopLoop() || realItems.length <= 3) return;

          const realCount = realItems.length;
          const beforeSecondLast = prepareClone(realItems[realCount - 2], "before-second-last");
          const beforeLast = prepareClone(realItems[realCount - 1], "before-last");
          const afterFirst = prepareClone(realItems[0], "after-first");
          const afterSecond = prepareClone(realItems[1], "after-second");
          const afterThird = prepareClone(realItems[2], "after-third");

          const beforeFragment = document.createDocumentFragment();
          beforeFragment.append(beforeSecondLast, beforeLast);
          track.prepend(beforeFragment);
          track.append(afterFirst, afterSecond, afterThird);

          desktopLoopReady = true;
        }

        function getDesktopRealLeftItem(index) {
          return getRealItems()[index] || null;
        }

        function getClone(position) {
          return track.querySelector('[data-sb-collection-gallery-clone="' + position + '"]');
        }

        function jumpToRealIndex(index) {
          const target = getDesktopRealLeftItem(index);
          if (!target) return;

          setTrackScrollInstant(getPairScroll(target));
          updateSegments(index);
        }

        function scrollDesktopTo(index, direction) {
          const realItems = getRealItems();
          const realCount = realItems.length;
          if (!desktopLoopReady || realCount <= 3) return;

          const nextIndex = ((index % realCount) + realCount) % realCount;
          let visualTarget = getDesktopRealLeftItem(nextIndex);
          let mustNormalize = false;

          if (direction === "previous" && activeIndex === 0) {
            visualTarget = getClone("before-last");
            mustNormalize = true;
          }

          if (direction === "next" && activeIndex === realCount - 1) {
            visualTarget = getClone("after-first");
            mustNormalize = true;
          }

          if (!visualTarget) return;

          track.scrollTo({ left: getPairScroll(visualTarget), behavior: "smooth" });
          updateSegments(nextIndex);

          if (loopTimer) window.clearTimeout(loopTimer);
          if (mustNormalize) {
            loopTimer = window.setTimeout(function () {
              jumpToRealIndex(nextIndex);
            }, 440);
          }
        }

        function scrollMobileTo(index) {
          const target = getRealItems()[index];
          if (!target) return;
          track.scrollTo({ left: getMobileScroll(target), behavior: "smooth" });
          updateSegments(index);
        }

        function scrollToIndex(index) {
          if (isDesktopLoop()) {
            const realCount = getRealItems().length;
            const normalizedIndex = ((index % realCount) + realCount) % realCount;
            const target = getDesktopRealLeftItem(normalizedIndex);
            if (!target) return;
            track.scrollTo({ left: getPairScroll(target), behavior: "smooth" });
            updateSegments(normalizedIndex);
          } else {
            scrollMobileTo(index);
          }
        }

        function getClosestVisualItem() {
          const currentScroll = track.scrollLeft;
          let closestItem = null;
          let smallestDistance = Infinity;

          getAllItems().forEach(function (item) {
            const targetScroll = isDesktopLoop() ? getPairScroll(item) : getMobileScroll(item);
            const distance = Math.abs(targetScroll - currentScroll);
            if (distance < smallestDistance) {
              smallestDistance = distance;
              closestItem = item;
            }
          });

          return closestItem;
        }

        function getActiveIndexFromScroll() {
          const closestItem = getClosestVisualItem();
          if (!closestItem) return 0;
          const itemIndex = parseInt(closestItem.getAttribute("data-sb-collection-gallery-index"), 10);
          return Number.isFinite(itemIndex) ? itemIndex : 0;
        }

        function normalizeClonePosition() {
          if (!isDesktopLoop() || !desktopLoopReady) return;
          const closestItem = getClosestVisualItem();
          if (closestItem && closestItem.hasAttribute("data-sb-collection-gallery-clone")) {
            jumpToRealIndex(getActiveIndexFromScroll());
          }
        }

        function setupLayout() {
          if (isDesktopLoop()) {
            createClones();
            requestAnimationFrame(function () {
              jumpToRealIndex(activeIndex);
            });
          } else {
            removeClones();
            requestAnimationFrame(function () {
              const realItems = getRealItems();
              const target = realItems[activeIndex] || realItems[0];
              if (!target) return;
              setTrackScrollInstant(getMobileScroll(target));
              updateSegments(activeIndex);
            });
          }
        }

        segments.forEach(function (segment, index) {
          segment.addEventListener("click", function () {
            scrollToIndex(index);
          });
        });

        if (previousButton) {
          previousButton.addEventListener("click", function () {
            scrollDesktopTo(activeIndex - 1, "previous");
          });
        }

        if (nextButton) {
          nextButton.addEventListener("click", function () {
            scrollDesktopTo(activeIndex + 1, "next");
          });
        }

        track.addEventListener("scroll", function () {
          if (scrollFrame) cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(function () {
            updateSegments(getActiveIndexFromScroll());
          });
        }, { passive: true });

        if ("onscrollend" in window) {
          track.addEventListener("scrollend", normalizeClonePosition);
        }

        window.addEventListener("resize", function () {
          if (resizeFrame) cancelAnimationFrame(resizeFrame);
          resizeFrame = requestAnimationFrame(setupLayout);
        });

        setupLayout();
      });
    }

    initCollectionStoryGalleries();

    /* =====================================================
       COLLECTION STORY — VIEW ALL SMOOTH SCROLL
       ===================================================== */

    /* =====================================================
       ANCRE #collection-models — RECALAGE À L'ARRIVÉE (17/08/2026)
       =====================================================

       LE DÉFAUT, ET SON MÉCANISME EXACT. En arrivant sur la page AVEC le
       fragment dans l'URL — le lien « Voir les modèles » du méga-menu depuis
       une autre page — le navigateur saute vers l'ancre pendant l'analyse du
       document. À cet instant, le contenu situé SOUS l'ancre n'a pas encore sa
       hauteur définitive : la grille ne porte qu'une carte et le pied de page
       suit de près. Le document est donc plus court qu'il ne sera, et l'ancre
       tombe AU-DELÀ du défilement maximal. Le navigateur ne peut pas aller
       plus loin : il bute sur le bas de page et s'arrête avant. Quand le
       contenu arrive enfin et que la page s'allonge, le défilement, lui, ne
       bouge plus. On reste au-dessus de la section, et les 132 px de padding
       noir du bas de la galerie large restent visibles.

       POURQUOI SEULEMENT DEPUIS UNE AUTRE PAGE. Depuis la page collection
       elle-même, le document est déjà à sa hauteur définitive : il n'y a rien
       contre quoi buter, et l'atterrissage est juste. C'est ce que Naji
       observe.

       POURQUOI PAS SUR MOBILE. La grille passe à deux colonnes et les cartes
       sont bien plus hautes : le contenu sous l'ancre dépasse largement la
       hauteur d'écran, le défilement maximal n'est jamais atteint.

       ⚠️ CE N'EST PAS UN DÉCALAGE VENANT DU DESSUS, et il ne faut pas chercher
       de ce côté. Mesuré au banc : un décalage inséré AU-DESSUS de l'ancre se
       corrige tout seul, même après le chargement — l'ancrage de défilement de
       Chrome s'en charge, et le thème ne pose `overflow-anchor: none` nulle
       part. Écartés de la même façon, mesure à l'appui : la marge d'ancrage
       (bien à zéro, et seule à viser cette section), le méga-menu (il ne
       verrouille pas le défilement), le JS des galeries (ses clones s'ajoutent
       horizontalement et son recentrage n'écrit que scrollLeft, qui ne fait
       pas défiler les ancêtres), et les images (hauteurs toutes réservées
       d'avance par min-height ou aspect-ratio).

       LE CORRECTIF. On surveille la HAUTEUR DU DOCUMENT — c'est elle qui
       change quand le contenu manquant arrive — et à chaque changement on
       remesure l'écart entre le haut de la section et le haut de l'écran. Si
       le navigateur avait buté, l'écart est non nul et on termine le voyage.
       S'il est nul, on ne touche à rien.

       ⚠️ TROIS GARDES, et elles comptent :
         · on n'agit QUE si le fragment est celui-ci — aucune autre ancre du
           site n'est concernée ;
         · on s'efface DÈS QUE l'utilisateur a touché au défilement : molette,
           doigt, clavier, souris. Rien ne doit sauter sous les yeux de
           quelqu'un qui lit déjà ;
         · on ne bouge que si l'écart dépasse un pixel — un sous-pixel n'est
           pas un défaut, c'est de l'arrondi de rendu.

       ⚠️ NE PAS ÉTENDRE au clic depuis la page elle-même : là, l'atterrissage
       est déjà juste, et la garde « l'utilisateur a défilé » serait fausse par
       construction — il a bien défilé, c'est ainsi qu'il est arrivé là. */
    (function alignerAncreModeles() {
      if (window.location.hash !== "#collection-models") return;

      const cible = document.querySelector("#collection-models");
      if (!cible) return;

      /* Trois secondes : au-delà, quelqu'un qui n'a toujours rien touché est en
         train de LIRE, et un saut serait pire que le défaut. */
      const FENETRE_MS = 3000;

      let actif = true;
      let observateur = null;

      function arreter() {
        actif = false;
        if (observateur) { observateur.disconnect(); observateur = null; }
      }

      ["wheel", "touchstart", "keydown", "mousedown"].forEach(function (type) {
        window.addEventListener(type, arreter, { passive: true, once: true });
      });

      function recaler() {
        if (!actif) return;
        const ecart = cible.getBoundingClientRect().top;
        if (Math.abs(ecart) <= 1) return;
        window.scrollTo({ top: window.pageYOffset + ecart, behavior: "auto" });
      }

      /* On surveille la HAUTEUR DU DOCUMENT, pas le temps qui passe : c'est
         elle qui change quand quelque chose s'insère au-dessus de l'ancre.
         Recaler ne la modifie pas — aucune boucle possible. */
      if (typeof ResizeObserver === "function") {
        observateur = new ResizeObserver(recaler);
        observateur.observe(document.documentElement);
      }

      window.addEventListener("load", function () {
        recaler();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(recaler);
        }
      });

      window.setTimeout(arreter, FENETRE_MS);
    })();

    document.querySelectorAll("[data-sb-collection-view-all]").forEach(function (link) {
      link.addEventListener("click", function (event) {
        const target = document.querySelector("#collection-models");

        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    });
  });
})();

/* SIFI BEAUVOIS — Page collection — NOTE (26/07/2026) : une glisse « une
   impulsion = un écran » entre le top lineup et la section suivante a été
   ajoutée puis RETIRÉE le même jour sur décision de Naji (d'abord désactivée
   sur mobile, puis partout). L'empilement du lineup reste ce qu'il était :
   du sticky pur CSS (collection.css, .sb-collection-lineup) — la section
   suivante le recouvre en défilant, avec un défilement 100 % natif.
   Ne pas réintroduire de moteur de glisse ici sans demande explicite. */